import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Select } from 'antd';
import TextLoop from 'react-text-loop';
import useChangeLanguage from '../../../containers/hooks/useChangeLanguage';
import { ReactComponent as EmployeeSvg } from '../../../assets/icons/employees.svg';
import ForgotPasswordForm from '../../../components/mobile/ForgotPasswordForm';

const { Title } = Typography;

const styles = {
  title: {
    margin: '15px 0 25px',
    whiteSpace: 'pre-line'
  },
  forgotPasswordtitle: {
    margin: '15px 0 25px',
    whiteSpace: 'pre-line',
    padding: '0 35px'
  }
};

function MobileForgotPassword() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();
  const { lang, langOptions, changeLanguage } = useChangeLanguage();

  const onChange = (value) => {
    const [language, direction] = value;
    changeLanguage(language, direction);
  };

  const onConfirm = () => {
    history.push('/welcome/status');
  };

  return (
    <>
     <Box paddingTop={40} paddingBottom={12} paddingX={20}>
        <Row type="flex" align="middle" gutter={24} style={{ width: '100%' }}>
          <Col>
            <div className="language-label">
              <TextLoop>
                {langOptions.map(({ value }) => (
                  <Title key={value} level={4} style={styles.title} >
                    {t(`common:language.title.${value}`)}
                  </Title>
                ))}
              </TextLoop>
            </div>
          </Col>
          <Col flex={1}>
            <div>
              <Select
                style={{ width: '90%' }}
                size="large"
                value={t(`common:language.${lang}`)}
                onChange={onChange}
              >
                {langOptions.map(({ value, direction }) => (
                  <Select.Option key={value} value={[value, direction]}>
                    {t(`common:language.${value}`)}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        <Box display="flex" justifyContent="center">
          <EmployeeSvg style={{ margin: '20', maxWidth: '80%' }} />
        </Box>
        <Box textAlign="center">
          <Row gutter={[0, 24]}>
            <Col xs={24}>
              <Title level={4} style={styles.forgotPasswordtitle}>
               {t('common:forgotPasswordTitle')}
              </Title>

            <ForgotPasswordForm
                onSubmit={onConfirm}
                onSubmitBtnText={t('common:button.submit')}
              />
              <div style={{textAlign: 'center', padding: 15}}>
                 <Link to="/login">{t('common:button.login')}</Link>
              </div>
              <Box backgroundColor="rgba(21, 169, 225, 0.05)" padding={12} marginTop={15}>
                <Title level={4} style={styles.title}>
                  {t('welcome:getStarted.info')}
                </Title>
              </Box>
            </Col>
          </Row>
        </Box>
      </Box>
    </>
  );
}

export default MobileForgotPassword;
